import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Plan sheet provider toggle: the Google segment's label.
export default class GooglePlayText extends BaseOption {
  static userInterfaceComponent = {
    label: "Google Play Label",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "Pay in Google Play";
}
